module.exports = __webpack_public_path__ + "img/4.9343b38a.png";